import { configureStore } from '@reduxjs/toolkit';
import authReducer from "../redux/slices/authSlice";
import categorySliceReducer from "../redux/slices/categorySlice";
import userSliceReducer from "../redux/slices/userSlice";
import blogSliceReducer from "../redux/slices/blogslice";
import businessSliceReducer from "../redux/slices/businessSlice"
import businessEnquiryReducer from "../redux/slices/businessEnquirySlice";
import siteDetailReducer from "../redux/slices/siteDetailSlice";
import contactReducer from "../redux/slices/contactSlice";
import adminMessageReducer from "../redux/slices/adminMessageSlice";
import rewardProductReducer from "../redux/slices/rewardProductSlice";
import planReducer from "../redux/slices/planSlice";
import adminReducer from "../redux/slices/adminSlice";
import blogCategoryReducer from "../redux/slices/blogCategorySlice";
import propertyReducer from "../redux/slices/propertySlice";


const store = configureStore({


  reducer: {

    auth: authReducer,
    admin: adminReducer,
    categories: categorySliceReducer,
    adminMessages: adminMessageReducer,
    users: userSliceReducer,
    blogs: blogSliceReducer,
    business: businessSliceReducer,
    businessEnquiry: businessEnquiryReducer,
    siteDetail: siteDetailReducer,
    contact: contactReducer,
    redeem: rewardProductReducer,
    plan: planReducer,
    blogCategory: blogCategoryReducer,
    property: propertyReducer

  },

});

export default store;
